import type { JSX } from "react";
import type { DocumentId, DocumentIssue } from "../index";
import type { EditorLabels } from "./labels";

export interface CompatibilityStateProps {
  documentId: DocumentId;
  raw: string;
  issue: DocumentIssue;
  labels: EditorLabels;
}

/**
 * Shown instead of an editor when stored content cannot be read. It never offers editing: the only
 * action is taking the original content out, byte for byte.
 */
export function CompatibilityState({
  documentId,
  raw,
  issue,
  labels,
}: CompatibilityStateProps): JSX.Element {
  const download = (): void => {
    const url = URL.createObjectURL(new Blob([raw], { type: "application/json" }));
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${documentId}.original.json`;
    anchor.click();
    // Revoked at once, some browsers cancel the download they were about to start.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return (
    <div className="ze-state ze-state-unreadable" role="alert" data-issue={issue.code}>
      <p className="ze-state-title">{labels.unreadableTitle}</p>
      <p className="ze-state-body">{labels.unreadableBody}</p>
      <p className="ze-state-detail">{issue.message}</p>
      <button type="button" className="ze-state-action" onClick={download}>
        {labels.exportOriginal}
      </button>
    </div>
  );
}
